export enum RecordFilterType {
  All = 'All',
  Candidate = 'Candidate',
  Position = 'Position',
  Survey = 'Survey'
}

export const recordFilterTypes = [
  RecordFilterType.Candidate,
  RecordFilterType.Position,
  RecordFilterType.Survey
];
